import React , {useState, useEffect}from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { loadAuthData } from '../../action/auth_action';
import { isAuthenticated, getUserData } from '../../util/util';

export const AuthGuardImpl = props => {
    // const [state, handleState] = useState({});

    useEffect(()=>{
        loadAuthData();
    },[])

    const { component: Template, ...rest } = props;
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated() ? (
            <Template {...props} />
          ) : (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: props.location }
              }}
            />
          )
        }
      />
    );
  }

AuthGuardImpl.propTypes = {
  loadAuthData: PropTypes.func.isRequired,
  component: PropTypes.any.isRequired
};

export default connect(null, {
  loadAuthData
})(AuthGuardImpl);


export const PublicRoute = ({ component: Template, ...rest }) => {
  const userInfo = getUserData();
  let redirectUrl = '';
  if (userInfo) {
      window.location.href = '/dashboard';
  }
  return (
    <Route
      {...rest}
      render={props =>
        !isAuthenticated() ? (
          <Template {...props} />
        ) : (
          <Redirect
            to={{
              pathname: redirectUrl,
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

PublicRoute.defaultProps = {
  location: {}
};

PublicRoute.propTypes = {
  component: PropTypes.any.isRequired,
  location: PropTypes.object
};



// WEBPACK FOOTER //
// ./web/components/signUp/authgaurd.jsx